import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AutoLogin } from "../pages/auth/store/auth.actions";
import { AppState } from "../store/root.reducer";
import { hasValidAccessToken } from "../utils/authToken";
import {
  shouldBypassAutoLoginForOfflineGallery,
} from "../components/3d/gallery.bootstrap";

let autoLoginDispatchInFlight = false;

export const useAutoLogin = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authLoading = useSelector((state: AppState) => state.auth.loading);

  useEffect(() => {
    if (!authLoading) {
      autoLoginDispatchInFlight = false;
    }
  }, [authLoading]);

  const handleRedirect = useCallback((): void => {
    localStorage.removeItem("accessToken");
    navigate("/auth/login");
  }, [navigate]);

  const autoLogin = useCallback((shouldRedirect: boolean = true) => {
    if (authLoading || autoLoginDispatchInFlight) {
      return;
    }

    const isOnline = typeof navigator === "undefined" ? true : navigator.onLine;
    if (
      shouldBypassAutoLoginForOfflineGallery(
        location.pathname,
        location.search,
        isOnline
      )
    ) {
      return;
    }

    const token = localStorage.getItem("accessToken");

    // Check for token validity
    // If the token is invalid or expired, remove it and optionally redirect to login page
    if (!hasValidAccessToken(token)) {
      if (shouldRedirect) handleRedirect();
      return;
    }

    try {
      autoLoginDispatchInFlight = true;
      dispatch(
        AutoLogin({ accessToken: token, path: location.pathname+location.search, navigate })
      );
    } catch (error) {
      autoLoginDispatchInFlight = false;
      console.error("AutoLogin failed", error);
    }
  }, [authLoading, dispatch, handleRedirect, location.pathname, location.search, navigate]);

  return autoLogin;
};
